import {
  Tag,
  Star,
  Flag,
  Heart,
  Zap,
  Crown,
  Flame,
  Bookmark,
  Bell,
  CircleCheck,
  CircleAlert,
  Clock,
  Rocket,
  Gift,
  Handshake,
  ShoppingCart,
  CreditCard,
  Headphones,
  Users,
  UserRound,
  Building2,
  Sparkles,
  ThumbsUp,
  ThumbsDown,
  Snowflake,
  TrendingUp,
} from "lucide-react";

/** Curated icon set for tags — keeps the bundle small (no `import *`). */
export const TAG_ICONS = {
  tag: Tag,
  star: Star,
  flag: Flag,
  heart: Heart,
  zap: Zap,
  crown: Crown,
  flame: Flame,
  bookmark: Bookmark,
  bell: Bell,
  check: CircleCheck,
  alert: CircleAlert,
  clock: Clock,
  rocket: Rocket,
  gift: Gift,
  handshake: Handshake,
  cart: ShoppingCart,
  card: CreditCard,
  support: Headphones,
  users: Users,
  user: UserRound,
  company: Building2,
  sparkles: Sparkles,
  up: ThumbsUp,
  down: ThumbsDown,
  cold: Snowflake,
  trending: TrendingUp,
};

export const TAG_ICON_NAMES = Object.keys(TAG_ICONS);

export function getTagIcon(name) {
  return TAG_ICONS[name] || null;
}

/** Preset colour palette for the tag editor. */
export const TAG_COLORS = [
  "#2F8FD4",
  "#0EA5E9",
  "#10B981",
  "#22C55E",
  "#84CC16",
  "#EAB308",
  "#F59E0B",
  "#F97316",
  "#EF4444",
  "#E11D48",
  "#EC4899",
  "#A855F7",
  "#8B5CF6",
  "#6366F1",
  "#64748B",
  "#0F172A",
];

const HEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

/** Chip styling from a hex colour: tinted bg, solid text + subtle border. */
export function tagChipStyle(color) {
  const c = HEX.test(color || "") ? color : "#2F8FD4";
  return {
    backgroundColor: `${c}1f`,
    color: c,
    borderColor: `${c}59`,
  };
}
